import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

const isAnimatingRef = { current: false };

export const handleScrollTo = (targetId: string, offset = 60) => {
	const element =
		document.getElementById(targetId) || (document.querySelector(`[data-testid="${targetId}"]`) as HTMLElement | null);

	if (!element || isAnimatingRef.current) return;

	isAnimatingRef.current = true;

	const isIOSSafari = /iPad|iPhone|iPod/.test(navigator.userAgent);

	const y = element.getBoundingClientRect().top + window.pageYOffset - offset;

	if (isIOSSafari) {
		window.scrollTo({ top: y, behavior: 'smooth' });
		setTimeout(() => {
			isAnimatingRef.current = false;
		}, 700);
	} else {
		try {
			const scrollContainer = document.scrollingElement || document.documentElement;
			gsap.killTweensOf(scrollContainer);
			gsap.to(scrollContainer, {
				scrollTo: { y, autoKill: false },
				duration: 0.6,
				ease: 'power1.out',
				onComplete: () => {
					isAnimatingRef.current = false;
				},
				onInterrupt: () => {
					isAnimatingRef.current = false;
				},
			});
		} catch {
			window.scrollTo({ top: y, behavior: 'smooth' });
			setTimeout(() => {
				isAnimatingRef.current = false;
			}, 700);
		}
	}
};
